<script>
  // import { tweened } from "svelte/motion";
  import { audioActive, audioEl, muted } from "../stores/global.js";

  const MAX = 0.4;
  // const volumeTween = tweened(0, { duration: 1000 });
  let el;

  const change = () => {
    if (!el) return;

    if (!$audioActive) {
      if (el.getAttribute("src")) el.pause();
      return;
    }

    const src = `assets/audio/${$audioActive}.mp3`;
    el.src = src;

    el.play();
  };

  $: $audioActive, change();
  $: if (el) el.volume = $muted ? 0 : MAX;
  $: if (el) $audioEl = el;
</script>

<audio bind:this="{el}" preload></audio>
